import { mountVueComponent } from '@/lib/mount-vue-component.js';

export default function () {
	import('./components/AIAgentForm.vue').then((aiAgentForm) => {
		mountVueComponent('ai-agent-form', aiAgentForm);
	});
}
